import logger from './logger';

const safelyParseJson = (json) => {
  try {
    return JSON.parse(json);
  } catch (e) {
    return {};
  }
};

const logPageView = () => {
  const pageView = document.querySelector('#logger-page-view');

  if (!pageView) {
    // eslint-disable-next-line no-console
    console.warn('Page view was not logged to Segment');

    return;
  }

  const {
    loggerCategory = null,
    loggerName = null,
    loggerAttributes = {},
    loggerUserId
  } = pageView.dataset;
  const attributes = safelyParseJson(loggerAttributes);

  if (loggerUserId) {
    logger.identify(loggerUserId);
  }

  logger.logPageView(loggerCategory, loggerName, attributes);
};

export default logPageView;
